// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/timeline"
import { TIME_GROUPS_DISPLAY_MODE, } from "../../../app/localStorageKeys"
import { TimeGroupsDisplayMode } from "../slices/timeline"

export type StorageWriter = (value: TimeGroupsDisplayMode) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(TIME_GROUPS_DISPLAY_MODE, value.toString())
}

export const persistTimeGroupsDisplayMode = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setTimeGroupsDisplayMode.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.timeGroupsDisplayModePersisted()),
        catchError(_ => of(Actions.timeGroupsDisplayModePersistFailed())),
      )),
    )

export default persistTimeGroupsDisplayMode(persist)
